/**
 * Created by amine on 02/11/2020.
 */
(function () {

    'use strict';


    class MedicalCareFilesCtrl {
        constructor(medicalCareService, patientService, configService, $q, $state, $transition$, $transitions) {
            this.medicalCareService = medicalCareService;
            this.configService = configService;
            this.patientService = patientService;
            this.q = $q;
            this.state = $state;

            this.currentPatient = _.get($transition$.params('to'), "pId");
            this.config = {};
            this.items = [];

            this.show = false;
            this.context = null;
            this.extraContext = null;
        }

        static get $inject() {
            return ["medicalCareService", "patientService", "configService", "$q", "$state", "$transition$", "$transitions"];
        }

        $onInit() {
            this.medicalCareService.linkSubject.next('files');
            this.formSubscription = this.medicalCareService.formSubject.subscribe(data => {
                const type = _.get(data, "type");
                const item = _.get(data, "item");

                if (type && type === 'plan') {
                    this.context = {medical_care_plan: item.id};
                    this.extraContext = {patient: this.currentPatient};
                } else {
                    this.context = {patient: this.currentPatient};
                    this.extraContext = {};
                }
                this.show = true;
            });
        }

        $onDestroy() {
            this.formSubscription.unsubscribe();
        }
    }

    module.exports = MedicalCareFilesCtrl;

})();
